module.exports = function templatesByGrouping(edges, type = 'category') {
  return edges
    .reduce((groups, { node }) => {
      node.groups.forEach((g) => {
        if (g.type === type) {
          if (!groups.find((x) => x.id === g.id)) {
            groups.push({ ...g });
          }
          const group = groups.find((x) => x.id === g.id);
          if (!group.templates) group.templates = [];

          group.templates.push(node);
        }
      });
      return groups;
    }, [])
    .sort((a, b) => {
      if (a.title > b.title) return 1;
      if (a.title < b.title) return -1;
      return 0;
    });
};
